import { render } from "./manage-member.vue?vue&type=template&id=26c27823&scoped=true&ts=true"
import script from "./manage-member.vue?vue&type=script&lang=ts"
export * from "./manage-member.vue?vue&type=script&lang=ts"

import "./manage-member.vue?vue&type=style&index=0&id=26c27823&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c27823"]])

export default __exports__